import * as React from "react"
import { TableSeeker } from "@ui-seeker/core"
import { reportTableChange, reportExcelDownload } from "@analytics/tableEvents"


// Every data table in the app goes through here instead of importing `TableSeeker` from
// `@ui-seeker/core` directly, which is what makes the analytics possible: one wrapper covers all
// ~70 tables without touching the package (shared by every app in the house) or 70 pages one by
// one.
//
// The events themselves live in `@analytics/tableEvents`, shared with `AppTableCore` — the older
// component that wraps mui-datatables directly and survives on one page, Monitoring › Results — so
// the two cannot drift apart. `BasicTableSeeker` (5 call sites) is a different component with a
// different contract and is covered by neither.
export default function AppTableSeeker({ options, title, ...props }) {
    return <TableSeeker
        {...props}
        title={title}
        options={{
            ...options,

            // mui-datatables funnels every interaction through here, and the package spreads the
            // `options` it receives straight into it without overriding this one — verified in
            // `ui-seeker-v2/src/Table/Base/index.jsx`.
            onTableChange: (action, state) => {
                reportTableChange(action, state, title)
                options?.onTableChange?.(action, state)
            },

            // The package calls this and chains `.finally()` on what it returns, so the original's
            // promise has to come back untouched. Pages that export pass their own `onDownload`
            // (53 of them), which is why the download is captured here and not in the toolbar.
            ...(options?.onDownload && {
                onDownload: (...args) => {
                    reportExcelDownload()
                    return options.onDownload(...args)
                }
            }),
        }}
    />
}
